var hashtag_default = {
  "fontElementMap": "JK5ie",
  "hashtag": "tJP4V"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
